<template>
  <base-page>
    <div class="rps_12e0" id="workload">
      <div class="x_container">
        <div class="x_fecha">
          Workload for the next week
        </div>
        <div class="parent">
          <div class="x_block" :key="option.id" v-for="option in workloadOptions">
              <img :id="option.id" :src="option.src" :alt="option.id" width="60" height="60"
                  :class="{'hover': option.isSelected}" @click="changeSelectedWorkload(option.value)" :value="option.value">
              <p class="opt-text">{{ option.text }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="rps_12e0" id="feelings">
      <div class="x_container">
        <div class="x_fecha" style="background-color: #17445F !important;">
          <h2 style="text-align: left; color: #FFF; font-size: 14px;">Now, a few important questions more: </h2>
        </div>
        <div class="x_fecha">
          How did you feel this week?
        </div>
        <div class="x_block" :key="option.id" v-for="option in happinessOptions">
          <img :id="option.id" :src="option.src" :alt="option.id" width="60" height="60"
              :class="{'hover': option.isSelected}" @click="changeSelectedHapiness(option.value)" :value="option.value">
        </div>
      </div>
    </div>

    <div class="rps_12e0" id="goals">
      <div class="x_container">
        <div class="x_fecha">
          Did you achieve your weekly goals?
        </div>
        <div class="x_block" :key="option.id" v-for="option in goalOptions">
          <img :id="option.id" :src="option.src" :alt="option.id" width="60" height="60"
              :class="{'hover': option.isSelected}" @click="changeSelectedGoals(option.value)" :value="option.value">
        </div>
      </div>
    </div>

    <div class="rps_12e0" id="knowledge">
      <div class="x_container">
        <div class="x_fecha">
          Have you learned something?
        </div>
        <div class="x_block" :key="option.id" v-for="option in knowledgeOptions">
          <img :id="option.id" :src="option.src" :alt="option.id" width="60" height="60"
              :class="{'hover': option.isSelected}" @click="changeSelectedKnowledge(option.value)" :value="option.value">
        </div>
      </div>
    </div>

    <div class="send-btn" id="send-btn">
      <button id="send" :disabled="disableBtn" :class="{'disabled': disableBtn}" @click="saveUserInfo">Next</button>
    </div>
  </base-page>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/firestore'

export default {
  name: 'user-form',
  data () {
    return {
      userId: null,
      workloadSelected: null,
      happinessSelected: null,
      knowledgeSelected: null,
      goalsSelected: null,
      currentWeek: this.$router.currentRoute.query.week
    }
  },
  mounted () {
    console.log(this.currentWeek)
    let {userId, carga} = this.$router.currentRoute.query
    this.workloadSelected = carga

    userId = userId || this.$store.getters.userId

    if (!userId) {
      console.warn('No userId found in query string or logged in!!')
    }

    this.userId = userId
  },
  computed: {
    disableBtn () {
      if (this.workloadSelected && this.happinessSelected && this.knowledgeSelected && this.goalsSelected) {
        console.log('DISABLE BTN FALSE')
        return false
      }
      console.log('DISABLE BTN TRUE')
      return true
    },
    happinessOptions (happinessSelected) {
      const options = [
        {
          id: 'green-face',
          src: require('../assets/green-face-off.svg'),
          value: '1'
        },
        {
          id: 'blue-face',
          src: require('../assets/blue-face-off.svg'),
          value: '2'
        },
        {
          id: 'yellow-face',
          src: require('../assets/yellow-face-off.svg'),
          value: '3'
        },
        {
          id: 'red-face',
          src: require('../assets/red-face-off.svg'),
          value: '4'
        }
      ]
      const ret = options.map(o => {
        o.isSelected = o.value === this.happinessSelected
        return o
      })
      return ret
    },
    workloadOptions (workloadSelected) {
      const options = [
        {
          id: 'wl-green',
          src: require('../assets/wl-green-off.svg'),
          text: 'I will be mostly free',
          value: '1'
        },
        {
          id: 'wl-orange',
          src: require('../assets/wl-orange-off.svg'),
          text: 'I will be busy, but I can help others.',
          value: '2'
        },
        {
          id: 'wl-red',
          src: require('../assets/wl-red-off.svg'),
          text: 'I won\'t have time to help others',
          value: '3'
        },
        {
          id: 'wl-black',
          src: require('../assets/wl-black-off.svg'),
          text: 'I will be very busy and will need help.',
          value: '4'
        },
        {
          id: 'wl-white',
          src: require('../assets/wl-white-off.svg'),
          text: 'I won\'t be available (vacations, etc).',
          value: '0'
        }
      ]
      const ret = options.map(o => {
        o.isSelected = o.value === this.workloadSelected
        return o
      })
      return ret
    },
    goalOptions (goalsSelected) {
      const options = [
        {
          id: 'fourstar-g',
          src: require('../assets/4-star-off.svg'),
          value: '1'
        },
        {
          id: 'threestar-g',
          src: require('../assets/3-star-off.svg'),
          value: '2'
        },
        {
          id: 'twostar-g',
          src: require('../assets/2-star-off.svg'),
          value: '3'
        },
        {
          id: 'onestar-g',
          src: require('../assets/1-star-off.svg'),
          value: '4'
        }
      ]
      const ret = options.map(o => {
        o.isSelected = o.value === this.goalsSelected
        return o
      })
      return ret
    },
    knowledgeOptions (knowledgeSelected) {
      const options = [
        {
          id: 'fourstar-k',
          src: require('../assets/4-star-off.svg'),
          value: '1'
        },
        {
          id: 'threestar-k',
          src: require('../assets/3-star-off.svg'),
          value: '2'
        },
        {
          id: 'twostar-k',
          src: require('../assets/2-star-off.svg'),
          value: '3'
        },
        {
          id: 'onestar-k',
          src: require('../assets/1-star-off.svg'),
          value: '4'
        }
      ]
      const ret = options.map(o => {
        o.isSelected = o.value === this.knowledgeSelected
        return o
      })
      return ret
    }
  },
  methods: {
    workloadScrollTo () {
      const feelings = document.getElementById('feelings')
      feelings.scrollIntoView()
    },
    feelingsScrollTo () {
      const goals = document.getElementById('goals')
      goals.scrollIntoView()
    },
    goalsScrollTo () {
      const knowledge = document.getElementById('knowledge')
      knowledge.scrollIntoView()
    },
    knowledgeScrollTo () {
      const sendBtn = document.getElementById('send-btn')
      sendBtn.scrollIntoView()
    },
    changeSelectedHapiness (value) {
      this.happinessSelected = value
      console.log('changeSelectedHappines: happinessSelected', this.happinessSelected)
      this.feelingsScrollTo()
    },
    changeSelectedWorkload (value) {
      this.workloadSelected = value
      console.log('changeSelectedWorkload: workloadSelected', this.workloadSelected)
      this.workloadScrollTo()
    },
    changeSelectedGoals (value) {
      this.goalsSelected = value
      console.log('changeSelectedGoals: goalsSelected', this.goalsSelected)
      this.goalsScrollTo()
    },
    changeSelectedKnowledge (value) {
      this.knowledgeSelected = value
      console.log('changeSelectedKnowledge: knowledgeSelected', this.knowledgeSelected)
    },
    saveUserInfo () {
      return firebase.firestore()
        .collection('traffic_light')
        .doc(`${this.userId.toLowerCase()}-${this.currentWeek}`)
        .set({
          userId: this.userId.toLowerCase(),
          workload: this.workloadSelected,
          happiness: this.happinessSelected,
          goals: this.goalsSelected,
          knowledge: this.knowledgeSelected,
          week: this.currentWeek
        })
        .then(() => {
          console.log('SAVED IN DATABASE')
          this.$router.push(`/thanks?userId=${this.userId}&workload=${this.workloadSelected}&happiness=${this.happinessSelected}&goals=${this.goalsSelected}&knowledge=${this.knowledgeSelected}&week=${this.currentWeek}`)
        })
        .catch((err) => console.error(err))
    }
  }
}
</script>

<style scoped>
#user-form {
  background: #17445F;
  margin: 0;
  font-family: 'Helvetica', 'Neue';
}
#app {
  margin-top: 0px !important;
}
.x_cabecera {
  color: #FFF;
  font-size: 13px;
  background-color: #4D6F84;
  text-align: center;
  padding: .5em;
}

h1 {
  margin: 0px;
}
rps_12e0 {
  margin-top: 2em !important;
}
.rps_12e0 .x_container {
  margin: 20px;
  border: 0px;
  text-align: center;
  background-color: #0F2D3E;
  font-size: 12px;
  max-width: 1000px;
  margin: 2em auto;
}
.rps_12e0 .x_container2 {
  width: 100%;
  margin: 20px;
  border: 0px;
  text-align: left;
  color: #FFF;
  font-size: 12px;
  padding-bottom: 20px;
}
.link-no-style {
  text-decoration: none;
  color: #FFF;
}
.rps_12e0 .x_block {
  background-color: #0F2D3E;
  display: inline-block;
  margin: 1em 0 1em 0;
  padding: 10px;
  width: 220px;
  border: 0px;
  text-align: center;
  color: #fff;
  max-height: 150px;
  vertical-align: middle;
  font-weight: bold;
}
.rps_12e0 .x_fecha{
  background: #2C556E;
  padding: 10px 0 10px 15px;
  color: #fff;
  font-size: 14px;
  text-align: left;
  font-weight: bold;
}

.rps_12e0 ul {
  list-style-type: none;
}
.rps_12e0 .x_fecha_form {
  margin-top: 0px;
  background-color: #769CB3;
  padding: 10px 0 10px 15px;
  color: #0F2D3E;
  font-weight: bold;
  font-size: 12px;
  text-align: left;
}

label.radio-hidden > input{
  visibility: hidden;
  position: absolute;
}
label.radio-hidden > input, img{
  cursor: pointer;
  /* border:2px solid transparent; */
}
label.radio-hidden > input:checked + img{
  border:2px solid #f00;
}

.send-btn {
  text-align: center;
  margin: -5em auto 5em auto;
  padding: 6em;
}
#send {
  padding: 1em;
  width: 117px;
  height: 35px;
  background-color: #769CB3;
  color: #000;
  font-weight: bold;
  border-style: none;
  border-radius: 8px;
}
#send:hover {
  cursor: pointer;
}
fieldset {
  border-style: none;
}

#green-face:hover,
#green-face.hover {
  background-image: url('../assets/green-face.svg');
  cursor: pointer;
}
#blue-face:hover,
#blue-face.hover {
  background-image: url('../assets/blue-face.svg');
  cursor: pointer;
}
#yellow-face:hover,
#yellow-face.hover {
  background-image: url('../assets/yellow-face.svg');
  cursor: pointer;
}
#red-face:hover,
#red-face.hover {
  background-image: url('../assets/red-face.svg');
  cursor: pointer;
}
#fourstar-g:hover,
#fourstar-g.hover,
#fourstar-k:hover,
#fourstar-k.hover {
  background-image: url('../assets/4-star.svg');
  cursor: pointer;
}
#threestar-g:hover,
#threestar-g.hover,
#threestar-k:hover,
#threestar-k.hover {
  background-image: url('../assets/3-star.svg');
  cursor: pointer;
}
#twostar-g:hover,
#twostar-g.hover,
#twostar-k:hover,
#twostar-k.hover {
  background-image: url('../assets/2-star.svg');
  cursor: pointer;
}
#onestar-g:hover,
#onestar-g.hover,
#onestar-k:hover,
#onestar-k.hover  {
  background-image: url('../assets/1-star.svg');
  cursor: pointer;
}
#wl-green:hover,
#wl-green.hover {
  background-image: url('../assets/wl-green.svg');
  cursor: pointer;
}
#wl-orange:hover,
#wl-orange.hover {
  background-image: url('../assets/wl-orange.svg');
  cursor: pointer;
}
#wl-red:hover,
#wl-red.hover {
  background-image: url('../assets/wl-red.svg');
  cursor: pointer;
}
#wl-black:hover,
#wl-black.hover {
  background-image: url('../assets/wl-black.svg');
  cursor: pointer;
}
#wl-white:hover,
#wl-white.hover {
  background-image: url('../assets/wl-white.svg');
  cursor: pointer;
}
.opt-container {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: left;
}
.opt-container > img {
  margin-right: 1em;
}
.opt-text {
  width: 100%;
  text-align: center;
  margin: 1em 0 1em 0;
}
.disabled {
  background-color: #a1a1a1 !important;
  color: #636363 !important;
  cursor: not-allowed !important;
}
#workload, #feelings, #goals, #knowledge {
  animation: ease;
}

@media (max-width: 600px) {
  .rps_12e0 .x_container {
    display: inherit !important;
  }
  .parent {
    display: flex;
    flex-wrap: wrap;
  }
  .x_block {
    display: inline-block !important;
    margin: 10px 0 0 10px !important;
    flex-grow: 1 !important;
    width: 100px !important;
  }
  .opt-text {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Form.vue